import { MutableRefObject, useEffect } from 'react';

export const useFocus = <T extends HTMLElement>(
	focused: boolean,
	isComponentFrameVisible: boolean,
	elRef: MutableRefObject<T>
): void => {
	useEffect(() => {
		if (focused && isComponentFrameVisible) {
			elRef.current.focus();
		}
	}, [focused]);
};
